
export default class BankCardUserAssignmentRequest{

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["assigned-to-user-id"] = obj.assignedToUserId;
        jsonObj["bank-card-barcodes"] = obj.bankCardBarcodes;

        return jsonObj;
    };
}
